import { useCallback, useEffect } from 'react'
import { useBeforeUnload, useBlocker } from 'react-router-dom'

const usePrompt = (when: boolean | (() => boolean)) => {
    const blocker = useBlocker(when)
    useEffect(() => {
        if (blocker.state === 'blocked' && !when) {
            blocker.reset()
        }
    }, [blocker, when])

    useBeforeUnload(
        useCallback(
            (event) => {
                if (
                    (typeof when === 'boolean' && when === true) ||
                    (typeof when === 'function' && when())
                ) {
                    event.preventDefault()
                }
            },
            [when]
        ),
        { capture: true }
    )

    return blocker
}

export default usePrompt
